"use client"
import AllProductPageComp from '@/components/ProductPage/AllProductPageComp';
import React from 'react';

function ProductDisplaySection() {
    return <AllProductPageComp />
}

export default ProductDisplaySection;